<form [formGroup]="formGroup">
  <div class="d-flex flex-column">
    <span class="small-title mb-4"> {{'createOffer.external.insurer'|translate}}</span>

    <app-input-field [control]="formGroup.controls.name" class="field-container"
                     [label]="'createOffer.external.name'|translate">
      <textarea name="name"
                cdkTextareaAutosize
                [cdkAutosizeMinRows]="3"
                formControlName="name" class="input input-text-area w-auto"> </textarea>
    </app-input-field>
    <div class="d-flex justify-content-between field-container">
      <app-input-field [control]="formGroup.controls.streetName" class="bigger-input"
                       [label]="'createOffer.external.street'|translate">
        <input name="street"
               formControlName="streetName"
               class="input">
      </app-input-field>

      <app-input-field [control]="formGroup.controls.houseNumber" class="smaller-input"
                       [label]="'createOffer.external.streetNumber'|translate">
        <input name="houseNumber"
               formControlName="houseNumber" class="input">
      </app-input-field>
    </div>

    <div class="d-flex justify-content-between field-container">
      <app-input-field [control]="formGroup.controls.postalCode" class="smaller-input"
                       [label]="'createOffer.external.postalCode'|translate">
        <input name="postalCode"
               formControlName="postalCode" type="text"
               class="input">
      </app-input-field>

      <app-input-field [control]="formGroup.controls.location" class="bigger-input"
                       [label]="'createOffer.external.location'|translate">
        <input name="location" formControlName="location"
               class="input">
      </app-input-field>
    </div>

    <div class=" mb-0 d-flex justify-content-between field-container">
      <app-input-field [control]="formGroup.controls.countryCode" class="smaller-input"
                       [label]="'createProposal.countryCode'|translate">
        <mat-select formControlName="countryCode"
                    class="countryCode input"
                    [value]="formGroup.value.countryCode" #singleSelect>
          <mat-option>
            <ngx-mat-select-search [formControl]="filterCtrlCountryCode" ngDefaultControl></ngx-mat-select-search>
          </mat-option>
          <mat-option>{{'createProposal.emptyOption'|translate}}</mat-option>
          <mat-option *ngFor="let option of filteredOptionsCountryCode |async" [value]="option">
            {{option}}
          </mat-option>

        </mat-select>
      </app-input-field>

      <app-input-field [control]="formGroup.controls.countryCode" class="bigger-input"
                       [label]="'createProposal.country'|translate">
        <mat-select formControlName="countryCode"
                    class="input"
                    [value]="formGroup.value.countryCode" #singleSelect>
          <mat-option>
            <ngx-mat-select-search [formControl]="filterCtrlCountry" ngDefaultControl></ngx-mat-select-search>
          </mat-option>
          <mat-option>{{'createProposal.emptyOption'|translate}}</mat-option>
          <mat-option *ngFor="let option of filteredOptionsCountry |async" [value]="getCountryCodeFromCountry(option)">
            {{option}}
          </mat-option>

        </mat-select>
      </app-input-field>
    </div>


  </div>
</form>
